import { format }   from "date-fns";
import cookies      from "js-cookie";
import { toLower }  from "lodash";
import http         from "../config/http";
import store        from "@/store/store";

var _admin, _tacId, _webkeyId;

export default {
    pmode: () => process.env.VUE_APP_PMODE,
    
    admin: () => store.state.admin,
    tacId() {
        return cookies.get('TAC_PBT_ID') ? cookies.get('TAC_PBT_ID') : store.state.tacId;
    },
    webkeyId() {
        return cookies.get('TAC_PBT_WEBKEY') ? cookies.get('TAC_PBT_WEBKEY') : store.state.webkeyId;
    },
    timeStamp: () => store.state.timeStamp,

    fmtDate: (d, f = 'do MMMM, yyyy') => {
        let out = '';
        try {
            // for some reason using '-' in dates causes an off by one error, format to y/m/d instead
            d = d.replace(/-/g, '/');
            out = format(new Date(d), f);
        }
        catch(e) { /* noop */ }

        return out;
    },
    fmtUrlParam: (s) => toLower(s.replace(/[^a-z0-9]/gi, '_').replace(/_+|\1/gi, '_')),
    sleep: async (time) => new Promise((resolve) => setTimeout(resolve, time)),

    callUrl: (type, id) => {
        let url = process.env.VUE_APP_SERVER;
        url += (toLower(type) == 'pr') ? process.env.VUE_APP_WEBPR_URL : process.env.VUE_APP_WEBER_URL;
        url += `?objtype=shortcut&startoption=reuse_last_session&startlink=view&startdata=${id}`;

        return url;
    },
    
    setWebkeyHelperCookies: async () => {
        
        console.log("call sessions.php5");
        const resp = await http.get("../webkey_auth/sessions.php5", { withCredentials: true });
        
        document.cookie = 'TAC_PBT_WEBKEY=' + resp.data.webkey + '; path=/; domain=localhost; SameSite=Lax'
        document.cookie = 'TAC_PBT_ID=' + resp.data.id + '; path=/; domain=localhost; SameSite=Lax'
        document.cookie = 'TAC_PBT_ADMIN=' + resp.data.admin + '; path=/; domain=localhost; SameSite=Lax'
        
        let cookies = Object.fromEntries(document.cookie.split("; ").map(r => r.split("=")));
        store.commit("webkeyId", resp.data.webkey);
        store.commit("tacId", resp.data.id);
        store.commit("admin", resp.data.admin);
    },
}
